import pagination from '../../utils/pagination'
import {
  GROUPS_BATCH_DELETE_REQUEST, GROUPS_BATCH_DELETE_SUCCESS, GROUPS_BATCH_DELETE_FAILURE,
  GROUPS_FETCH_MANY_REQUEST, GROUPS_FETCH_MANY_SUCCESS, GROUPS_FETCH_MANY_FAILURE,
  GROUPS_FETCH_REQUEST, GROUPS_FETCH_SUCCESS, GROUPS_FETCH_FAILURE,
  GROUPS_SAVE_REQUEST, GROUPS_SAVE_SUCCESS, GROUPS_SAVE_FAILURE,
  
  EMPTY_GROUPS,
  CLEAR_ERRORS
} from './types'

export default {
  [GROUPS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [GROUPS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [GROUPS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [GROUPS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [GROUPS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [GROUPS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [GROUPS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [GROUPS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [GROUPS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [GROUPS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [GROUPS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [GROUPS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_GROUPS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
